import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import type { Playlist } from 'types/playlist'
import {
  deletePlaylist,
  deletePlaylistVersion,
} from '@disco/state-management/actions/ServerActions'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import ChoiceList from 'components/ui/choice-list'
import ModalDialog from 'components/ui/modal-dialog'

const mapStateToProps = (state, props) => {
  return {
    playlist: getPlaylist(state, {
      id: props.params.playlistId,
    }),
  }
}

const mapDispatchToProps = {
  deletePlaylist,
  deletePlaylistVersion,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type State = {
  deleteAllVersionsValue: boolean
}
type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  navigate: NavigateFunction
}

class DeletePlaylist extends React.Component<Props, State> {
  state = {
    deleteAllVersionsValue: false,
  }
  _onDeletePlaylist = () => {
    this.props.deletePlaylist(this.props.playlist)

    this._closeModal()
  }
  _onDeletePlaylistLatestVersion = () => {
    this.props.deletePlaylistVersion(this.props.playlist)

    this._closeModal()
  }
  _closeModal = () => this.props.navigate('/')

  render() {
    return (
      <ModalDialog
        title="Delete playlist"
        primaryAction={{
          caption: 'Confirm',
          onClick: () =>
            this.state.deleteAllVersionsValue
              ? this._onDeletePlaylist()
              : this._onDeletePlaylistLatestVersion(),
        }}
        status="danger"
        onCancel={this._closeModal}
      >
        <p>
          Are you sure you want to permanently delete this playlist? This can’t
          be undone.
        </p>
        <ChoiceList
          multiple={false}
          items={[
            {
              label: 'All Versions',
              value: true,
            },
            {
              label: 'Latest Version',
              value: false,
            },
          ]}
          selected={this.state.deleteAllVersionsValue}
          onChange={(value: boolean) =>
            this.setState({
              deleteAllVersionsValue: value,
            })
          }
        />
      </ModalDialog>
    )
  }
}

const ConnectedDeletePlaylist = connector(DeletePlaylist)

function DeletePlaylistWithNavigation(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ playlistId: string }>()
  return (
    <ConnectedDeletePlaylist {...props} navigate={navigate} params={params} />
  )
}

export default DeletePlaylistWithNavigation
